import { Box, Typography } from '@mui/material';
import React from 'react';

import Storefront from '@mui/icons-material/Storefront';
import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';

import { ITEM_SOURCE_COMBINED_LABEL, ITEM_SOURCE_LABEL } from '../../../constants/reports';
import variables from '../../../contexts/ThemeProvider/variables';
import { ItemSourceEnum } from '../../../types/marketplace';

const SOURCE_ICON: Record<ItemSourceEnum, typeof Storefront> = {
  [ItemSourceEnum.IeWarehouse]: WarehouseOutlinedIcon,
  [ItemSourceEnum.Marketplace]: Storefront,
};

const SOURCE_COLOR: Record<ItemSourceEnum, string> = {
  [ItemSourceEnum.IeWarehouse]: variables.defaultAccentColor,
  [ItemSourceEnum.Marketplace]: variables.marketplaceAccent,
};

interface IProps {
  sources: ItemSourceEnum[];
}

const ReportItemSource = ({ sources }: IProps) => {
  const isCombined = sources.length > 1;
  const labels = isCombined ? ITEM_SOURCE_COMBINED_LABEL : ITEM_SOURCE_LABEL;

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5, whiteSpace: 'nowrap' }}>
      {sources.map((source, index) => {
        const Icon = SOURCE_ICON[source];

        return (
          <Box key={source} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            {index > 0 && (
              <Typography component="span" sx={{ mr: 0.5 }} color="text.secondary">
                +
              </Typography>
            )}
            <Icon sx={{ fontSize: 16, color: SOURCE_COLOR[source] }} data-testid={`item-source-icon-${source}`} />
            <Typography component="span">{labels[source]}</Typography>
          </Box>
        );
      })}
    </Box>
  );
};

export default ReportItemSource;
